import * as React from "react";

import Container from "@client/content/Containers/container";
import { getContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { useResizeDetector } from "react-resize-detector";
import ImagePreview from "./ImagePreview/container";
import ThumbnailList from "./ThumbnailList/container";

import "./style.less";

export type ImageGalleryMapProps = RootContainerProps & {
  className: string;
  itemsIds: string[];
  selectedItemId: string | null;
  thumbnailsPosition: string;
};
export interface ImageGalleryActionProps {
  setSelectedItem: (id: string) => void;
}
type ImageGalleryProps = ImageGalleryActionProps & ImageGalleryMapProps;

const ImageGallery = (props: ImageGalleryProps) => {
  React.useEffect(() => {
    if (props.itemsIds.length && !props.selectedItemId) {
      props.setSelectedItem(props.itemsIds[0]);
    }
  }, [props.itemsIds.length, props.selectedItemId]);

  const setHeight = React.useCallback(() => {
    if (!ref.current) return;

    const previewImageEl = ref.current.querySelector(".preview_image .wsc_image") as HTMLElement;
    const thumbnailListEl = ref.current.querySelector(".thumbnail_list") as HTMLElement;

    if ((previewImageEl && props.thumbnailsPosition === "left") || props.thumbnailsPosition === "right") {
      thumbnailListEl.style.height = `${previewImageEl.offsetHeight}px`;
    } else {
      thumbnailListEl.style.height = "";
    }
  }, [props.thumbnailsPosition]);

  const { ref } = useResizeDetector({
    onResize: setHeight
  });

  const { className, itemsIds, setSelectedItem, selectedItemId, ...rest } = props;
  return (
    <Container {...getContainerProps(rest)}>
      {!!itemsIds.length && (
        <div className={className} ref={ref}>
          <ThumbnailList {...props} />
          <ImagePreview {...props} onLoaded={setHeight} />
        </div>
      )}
    </Container>
  );
};

export default ImageGallery;
